import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 400 400\" id=\"icon-mail\">\r\n<style type=\"text/css\">\r\n\t#icon-mail .st0{fill:#F38F38;}\r\n</style>\r\n<g id=\"icon-mail_mail.psd\">\r\n\t<g id=\"icon-mail__x2D_s-admin_icon\">\r\n\t\t<path class=\"st0\" d=\"M321,91c16.5,0,30,13.5,30,30v150c0,16.5-13.5,30-30,30H81c-16.5,0-30-13.5-30-30V121c0-16.5,13.5-30,30-30\r\n\t\t\tH321 M321,61H81c-33.1,0-60,26.9-60,60v150c0,33.1,26.9,60,60,60h240c33.1,0,60-26.9,60-60V121C381,87.9,354.1,61,321,61L321,61z\" />\r\n\t\t<path class=\"st0\" d=\"M198.8,237.6c-9.1,0-18.2-2.6-26.1-7.9l-145-96.3l16.6-25l145,96.3c5.7,3.8,13.2,3.9,18.9,0.1l149.7-96.5\r\n\t\t\tl16.3,25.2l-149.7,96.5C216.6,235.1,207.7,237.6,198.8,237.6z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mail.svg
// module id = CFfD
// module chunks = 32